import { Layout } from '@/views/configuration';

export default {
    path: '/configuration',
    component: Layout,
    children: [
        { path: 'summary', component: () => import('@/views/configuration/Summary.vue') },
    ]
};
